// Libraries
import clsx from "clsx";
import { Stack, Typography, Button, CircularProgress } from "@mui/material";

type THeaderSectionProps = {
	disabled: {
		discardButton: boolean;
		applyButton: boolean;
	};
	isSaving: boolean;
	handleDiscardChanges: () => void;
	handleApplyMapping: () => void;
};

export default function HeaderSection(props: Readonly<THeaderSectionProps>) {
	const { disabled, isSaving, handleApplyMapping, handleDiscardChanges } = props;
	const { applyButton, discardButton } = disabled;

	return (
		<Stack direction={"row"} alignItems="center" justifyContent="space-between">
			<Typography className={"page-title"}>Custom Field Items</Typography>
			{/* Action Buttons */}
			<Stack direction={"row"} spacing={4}>
				<Button
					variant="contained"
					className={clsx({
						"!rounded-md !h-[30px] w-[125px] !font-normal !normal-case !font-sans text-[14px] !shadow-none": true,
						"!bg-gray-blue hover:!shadow-gray-blue-shadow-50": !discardButton,
						"!bg-disabled !text-white": discardButton,
					})}
					onClick={handleDiscardChanges}
					disabled={discardButton}
				>
					Discard Changes
				</Button>
				<Button
					variant="contained"
					className={clsx({
						"!rounded-md !h-[30px] w-[125px] !font-normal !normal-case !font-sans !text-[14px] !shadow-none": true,
						"!bg-primary hover:!shadow-primary-shadow-50": !applyButton,
						"!bg-disabled !text-white": applyButton,
					})}
					onClick={handleApplyMapping}
					disabled={applyButton}
				>
					{isSaving ? <CircularProgress sx={{ color: "white", marginX: "28px" }} size={20} /> : "Apply Mapping"}
				</Button>
			</Stack>
		</Stack>
	);
}
